import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CommonService from '../../services/commonService';

export default class KuposRadio extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    label: PropTypes.string,
  };


  renderCard = card => {
    let cardTypesStatic= {
      "1": "visa",
      "2": "americanexpress",
      "3": "mastercard",
      "4": "diners",
      "5": "magna",
      "6": "redcompra"
  }
    let metaData = JSON.parse(localStorage.getItem('metaData') || '{}');
    let cardTypes = metaData && metaData.card_type || cardTypesStatic;
  
    return (
      <div style={{display:'flex', flexDirection:'row', gap:'10px', alignItems:"center"}}>
        <div>
          <img
            width={42}
            style={{ width: 42 }}
         
            src={card && card.card_type_name == 'americanexpress'
            ? '/static/images/cards/americanexpress.png'
            : card.card_type_name == 'diners'
            ? '/static/images/cards/diners.png'
            : card.card_type_name == 'magna'
            ? '/static/images/cards/magna.png'
            : card.card_type_name == 'mastercard'
            ? '/static/images/cards/mastercard.png'
            : card.card_type_name == 'redcompra'
            ? '/static/images/cards/redcompra.png'
            : '/static/images/cards/visa.png'}
        
            alt=""
          />
        </div>
        <div>
          <span>
            {card['card_number'].replace(/X/gi, '*').substring(8, 12)}
          </span>
          <br />
          <span>
            {card['card_number'].substring(12, 16)}
          </span>
        </div>
      </div>
    );
  };

  render() {
    return (    
      <div className="common-kupos-radio">
        {this.props.disabled ? (
          <span>
            <div className="kupos-radio">
              <span className={this.props.checked ? 'active' : ''}></span>
              {this.props.checked ? (
                <div className="icon-selection-circle-selected"></div>
              ) : (
                <div className="icon-selection-circle-not-selected"></div>
              )}
            </div>
            {this.props.isCard && this.renderCard(this.props.cardDetails)}
            {!this.props.isCard && this.props.showLogo ? (
              <div>
                <img style={{ width: 150 }} src={this.props.showLogo} alt="logo" /><br />
                <span>{this.props.label}</span>
              </div>
              
            ) : (
              <span>{this.props.t ? this.props.t(this.props.label) : this.props.label}</span>
            )}
          </span>
        ) : (
          <label>
            <div className="kupos-radio">
              <input
                type="radio"
                checked={this.props.checked}
                // onChange={this.props.onChange ? this.props.onChange : () => {}}
                onClick={this.props.onChange ? this.props.onChange : () => {}}
              />
              <span className={this.props.checked ? 'active' : ''}></span>
              {this.props.checked ? (
                <div className="icon-selection-circle-selected"></div>
              ) : (
                <div className="icon-selection-circle-not-selected"></div>
              )}
            </div>
            {/*  */}
            {!this.props.isCard && this.props.showLogo ? (
              <div>
              <img style={{ width: 150 }} src={this.props.showLogo} alt="logo" /><br />
              <span className="font-16px ">{CommonService.currency(+this.props.label).split(',')[0]}</span>
            </div>
            ) : (
              <span>{this.props.t ? this.props.t(this.props.label) : this.props.label}</span>
            )}

            {this.props.isCard && this.renderCard(this.props.cardDetails)}
          </label>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/KuposRadio.js